<template>
  <div class="stage-node">
    <!-- 当前阶段 -->
    <el-row style="margin:10px 0;" gutter="5">
      <el-col :span="2">
        <!-- 显示层级编号 -->
        <span class="level-index">{{ levelIndex }}</span>
      </el-col>
      <el-col :span="14">
        <el-input v-model="stage.name" placeholder="阶段名称"></el-input>
      </el-col>
      <el-col :span="5">
        <el-button @click="$emit('add-child', stage.nanoid)" type="primary" size="small">
          + 子任务
        </el-button>
      </el-col>
      <el-col :span="3">
        <div class="close" @click="$emit('remove', stage.nanoid)">
          <el-icon>
            <ElIconClose></ElIconClose>
          </el-icon>
        </div>
      </el-col>
    </el-row>

    <!-- 子阶段（递归渲染） -->
    <div v-if="stage.children.length" style="margin-left: 55px; border-left: 2px solid #eee">
      <stage-node
          v-for="(child, index) in stage.children"
          :key="child.nanoid"
          :stage="child"
          :parentIndex="levelIndex"
          :currentIndex="index + 1"
      @add-child="$emit('add-child', $event)"
      @remove="$emit('remove', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "StageNode",
  props: {
    stage: {
      type: Object,
      required: true,
    },
    parentIndex: {
      type: String,
      default: ''
    },
    currentIndex: {
      type: Number,
      default: 1
    }
  },
  computed: {
    levelIndex() {
      return this.parentIndex
          ? `${this.parentIndex}.${this.currentIndex}`
          : `${this.currentIndex}`;
    }
  }
};
</script>

<style scoped>
/* 连接线增强 */
.stage-node > .el-row {
  position: relative;
  padding-left: 10px;
  display: flex;
  align-items: center; /* 确保编号和输入框在同一行 */
}

.stage-node > .el-row:after {
  content: '';
  position: absolute;
  left: -15px;
  top: 50%;
  transform: translateY(-50%);
  width: 10px;
  height: 2px;
  background: #4dabf7;
}

/* 按钮样式调整 */
.close {
  font-size: 15px;
  text-align: right;
}

.level-index {
  display: inline-block;
  min-width: 40px;
  font-weight: bold;
  color: #4dabf7;
}
</style>